import Lustar from "assets/images/etc/lustar_transparent.png";
import Lucia from "assets/images/etc/lucia_transparent.png";

// Material Kit 2 React components
import MKTypography from "components/MKTypography";

const date = new Date().getFullYear();

export default {
  brand: {
    name: "JOHEUNBICH(좋은빛)",
    route: "/",
  },
  socials: [
    {
      icon: <img src={Lustar} alt="Lustar" style={{ width: "100px", height: "24px" }} />, // PNG 이미지로 변경
    },
    {
      icon: <img src={Lucia} alt="Lucia" style={{ width: "100px", height: "33px" }} />, // PNG 이미지로 변경
    },
  ],
  menus: [
    {
      name: "주소",
      items: [{ name: "34369" }, { name: "대전광역시 대덕구 대화로 284-3 번지" }],
    },
    {
      name: "연락처",
      items: [
        { name: "Office: 042-631-1504" },
        { name: "Fax: 042-638-1504" },
        { name: "Email: joheunbich@naver.com" },
      ],
    },
    {
      name: "고객지원",
      items: [{ name: "고객지원으로 이동 >", href: "/support" }],
      status: false,
    },
  ],
  copyright: (
    <MKTypography variant="button" fontWeight="regular">
      All rights reserved. Copyright &copy; {date} Material Kit by{" "}
      <MKTypography
        component="a"
        href="https://www.creative-tim.com"
        target="_blank"
        rel="noreferrer"
        variant="button"
        fontWeight="regular"
      >
        Creative Tim
      </MKTypography>
      .
    </MKTypography>
  ),
};
